import * as React from "react";
import { Link } from "react-router-dom";
import { Paths } from "../../../../constants";

interface OwnProps {
    eventId: number;
    guid: string;
    isNew: boolean;
    view?: undefined | "" | "details" | "uploads" | "permissions" | "settings";
}

export const Navigation: React.SFC<OwnProps> = (props) => {
    const v = props.view;
    const tAuthorship = "Authorship";
    const tDetails = "Details";
    const tUplaods = "Uploads";
    const tPerms = "Permissions";
    const tSettings = "Admin settings";

    return <ul className="nav-secondary">
            <li className={!v ? "current" : ""}><Link to={Paths.AdminAbstractEdit(props.eventId, props.guid)}>{tAuthorship}</Link></li>

            {props.isNew
                ? <>
                    <li className="disabled"><span>{tDetails}</span></li>
                    <li className="disabled"><span>{tUplaods}</span></li>
                    <li className="disabled"><span>{tPerms}</span></li>
                    <li className="disabled"><span>{tSettings}</span></li>
                </>
                : <>
                    <li className={v === "details" ? "current" : ""}><Link to={Paths.AdminAbstractEditDetails(props.eventId, props.guid)}>{tDetails}</Link></li>
                    <li className={v === "uploads" ? "current" : ""}><Link to={Paths.AdminAbstractEditUploads(props.eventId, props.guid)}>{tUplaods}</Link></li>
                    <li className={v === "permissions" ? "current" : ""}><Link to={Paths.AdminAbstractEditPermissions(props.eventId, props.guid)}>{tPerms}</Link></li>
                    <li className={v === "settings" ? "current" : ""}><Link to={Paths.AdminAbstractEditSettings(props.eventId, props.guid)}>{tSettings}</Link></li>
                </>
            }
        </ul>;
};



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/Navigation.tsx